// extracted by mini-css-extract-plugin
module.exports = {"title":"index_title__wBIvK","subTitle":"index_subTitle__PwSRA"};